import React from "react";
import PreNav from "./components/PreNav";
import Navbar from './components/Navbar';
import Home from "./components/Home";
import InfoSection from "./components/InfoSection";
import Footer from "./components/Footer";
function App() {
  return (
 <>
<PreNav/>
<Navbar/>
<Home/>
<InfoSection/>
<Footer/>
   </>
  );
}

export default App;
